<template>
    <div>
        <vue-headful :title="(this.id ? 'Edit' : 'Create') + ' [Product Types] - AMOS365'" />

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/admin/settings#product_types">Settings</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page" v-if="!type.id">Create Product Type</li>
                <li class="breadcrumb-item active" aria-current="page" v-else>Edit Product Type</li>

            </ol>
        </nav>

        <h4 class="page-header">
            <span v-if="id">Edit: {{ type.product_type_name }}</span>
            <span v-else>Create Product Type</span>
        </h4>

        <div class="row">
            <div class="col-lg-8">
                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Details</strong>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.product_type_name, 'text-muted-no': !errors.product_type_name}">
                                Type Name: <i class="fa fa-asterisk text-danger fa-sm"></i>
                            </div>
                            <div class="col-md-8 col-12 input-group-sm">
                                <input type="text" v-model="type.product_type_name" :class="{'form-control': true, 'is-invalid': errors.product_type_name}" placeholder="Enter Product Type Name" />

                                <div class="text-danger mt-1" v-if="errors.product_type_name">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.product_type_name">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-success" v-on:click="postSave()" :disabled="saving">
                    <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving</template>
                    <template v-else>Save Product Type</template>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                errors: {},
                type: {},
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            getData(){
                //Send it
                this.$http.get('/admin/product-types' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set Data
                        this.type = response.data.type;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            postSave(){
                //Set
                this.saving = true;

                //Send it
                this.$http.post('/admin/product-types', this.type)
                    .then(response => {
                        //Alert the user
                        this.$toastr.s('Product Type Saved');

                        //Set Back to Settings
                        this.$router.push('/admin/settings#product_types');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //Get the Data
            this.getData();
        }
    }
</script>